import type { AxiosRequestConfig } from "axios";
import qs from "qs";
import { axiosInstance } from "../../axios-instance";
import { qsOptions } from "../qsOptions";
import type { R } from "../types";
import type {
  IDeleteClientRequest,
  IDeleteClientResponse,
  IGetClientProfileByUserIdRequest,
  IGetClientProfileByUserIdResponse,
  IGetClientsRequest,
  IGetClientsResponse,
  IUpdateClientPropertyRequest,
  IUpdateClientPropertyResponse,
  IUpdateClientRequest,
  IUpdateClientResponse,
} from "./types";

export class ClientsService {
  async getAll(
    p: IGetClientsRequest,
    c?: AxiosRequestConfig,
  ): R<IGetClientsResponse> {
    try {
      const params = qs.stringify(p, qsOptions);
      return axiosInstance.get(`/api/client/all?${params}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async deleteClient(
    p: IDeleteClientRequest,
    c?: AxiosRequestConfig,
  ): R<IDeleteClientResponse> {
    try {
      return axiosInstance.delete(`/api/client/${p.userId}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async updateClient(
    p: IUpdateClientRequest,
    c?: AxiosRequestConfig,
  ): R<IUpdateClientResponse> {
    try {
      return axiosInstance.put(`/api/client/update`, p, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async updateClientProperty(
    p: IUpdateClientPropertyRequest,
    c?: AxiosRequestConfig,
  ): R<IUpdateClientPropertyResponse> {
    try {
      const params = qs.stringify(p, qsOptions);
      return axiosInstance.put(`/api/client/addProperty?${params}`, {}, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getProfileByUserId(
    p: IGetClientProfileByUserIdRequest,
    c?: AxiosRequestConfig,
  ): R<IGetClientProfileByUserIdResponse> {
    try {
      return axiosInstance.get(`/api/client/user/${p.userId}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
